/**
 * CI-22535: Orígenes de búsqueda del Trip Lookup en Kiosko AM.
 * Se registra en New Relic (evento get_reservation) para medir
 * qué método de búsqueda utiliza el pasajero.
 */
export enum SEARCH_ORIGIN {
  PASSPORT_SCAN = 'passport_scan',
  QR_SCAN = 'qr_scan',
  BOARDING_PASS_SCAN = 'boarding_pass_scan',
  PNR_LASTNAME = 'pnr_lastname',
  ETICKET_LASTNAME = 'eticket_lastname',
  DESTINATION_NAME = 'destination_name',
}
